import * as i0 from '@angular/core';
import { NgModule } from '@angular/core';
import { FormlyFormFieldModule } from '@ngx-formly/primeng/form-field';
import { FormlyInputModule } from '@ngx-formly/primeng/input';
import { FormlyTextAreaModule } from '@ngx-formly/primeng/textarea';
import { FormlyRadioModule } from '@ngx-formly/primeng/radio';
import { FormlyCheckboxModule } from '@ngx-formly/primeng/checkbox';
import { FormlySelectModule } from '@ngx-formly/primeng/select';

class FormlyPrimeNGModule {
}
FormlyPrimeNGModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: FormlyPrimeNGModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FormlyPrimeNGModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: FormlyPrimeNGModule, imports: [FormlyFormFieldModule,
        FormlyInputModule,
        FormlyTextAreaModule,
        FormlyRadioModule,
        FormlyCheckboxModule,
        FormlySelectModule] });
FormlyPrimeNGModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: FormlyPrimeNGModule, imports: [[
            FormlyFormFieldModule,
            FormlyInputModule,
            FormlyTextAreaModule,
            FormlyRadioModule,
            FormlyCheckboxModule,
            FormlySelectModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: FormlyPrimeNGModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        FormlyFormFieldModule,
                        FormlyInputModule,
                        FormlyTextAreaModule,
                        FormlyRadioModule,
                        FormlyCheckboxModule,
                        FormlySelectModule,
                    ],
                }]
        }] });

/*
 * Public API Surface of primeng
 */

/**
 * Generated bundle index. Do not edit.
 */

export { FormlyPrimeNGModule };
